// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SettingsOutlineComponent} from './SettingsOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSettingsOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SettingsOutlineComponent/>
  </Icon>
));
